import { setDefaults, getNodeDeserializer } from '@udecode/slate-plugins';
import linkElement from './element';

const deserializeLink = options => {
  const { link } = setDefaults(options, linkElement);

  return {
    element: getNodeDeserializer({
      type: link.type,
      node: el => ({
        type: link.type,
        url: el.getAttribute('href'),
      }),
      rules: [{ nodeNames: 'A' }],
    }),
  };
};

export default deserializeLink;
